import { Link } from "react-router-dom"
import logoutIcon from "../../assets/images/new-box-arrow-right.svg"

export const MobileMenu = () => {
    return (
        <div
            className="modal modal-fullscreen fade text-center d-lg-none"
            id="navicon"
            role="dialog"
            aria-hidden="true"
        >
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header border-0 mt-2 mr-2">
                        <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <i className="fas fa-times" />
                        </button>
                    </div>
                    <div className="modal-body">
                        <hr className="hr-star-blue mx-3" />
                        <ul className="list-unstyled">
                            <li>
                                <div className="mt-2">
                                    <Link to={"/post-idea"} data-dismiss="modal"
                                        className="btn btn-primary text-white text-uppercase rounded-10 font-lato font-12 py-15"
                                    >
                                        #MyIdea
                                    </Link>
                                </div>
                            </li>
                            <li>
                                <div className="mt-2">
                                    <Link to={"/post-idea"} data-dismiss="modal"
                                        className="btn btn-primary text-white text-uppercase rounded-10 font-lato font-12 py-15"
                                    >
                                        #MyShowcase
                                    </Link>
                                </div>
                            </li>
                            <li>
                                <div className="mt-2">
                                    <Link to={"/post-idea"} data-dismiss="modal"
                                        className="btn btn-primary text-white text-uppercase rounded-10 font-lato font-12 py-15"
                                    >
                                        #MyChallenge
                                    </Link>
                                </div>
                            </li>
                            
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}